<template>
  <div
    class="mini-chat bg-card p-2 rounded mx-auto"
    style="height: auto; max-height: 50vh; max-width: 600px"
  >
    <!-- Header -->

    <!-- Chat Messages -->
    <div class="chat-messages">
      <p v-if="messages.length === 0" class="text-center mt-3">
        No hay comentarios
      </p>
      <div
        v-for="(message, index) in messages"
        :key="index"
        class="d-flex my-3"
        :class="{
          'flex-row-reverse': message.user === 'Tú',
          'flex-row': message.user !== 'Tú',
        }"
      >
        <vs-avatar
          size="25"
          primary
          :danger="message.user === ''"
          class="mt-3"
          style="min-width: 25px !important"
        >
          <template v-show="message.user !== ''" #text>
            {{ message.user }}
          </template>
          <i
            v-show="message.user === ''"
            class="ti ti-user"
            style="font-size: 1rem"
          ></i>
        </vs-avatar>

        <div class="d-flex flex-column mx-2" style="max-width: 400px">
          <small
            :class="{
              'text-right': message.user === 'Tú',
            }"
          >
            {{ message.fecha | moment("from", "now") }}
          </small>
          <div
            class="chat-text bg-dark"
            :class="{
              right: message.user === 'Tú',
            }"
          >
            {{ message.text }}
          </div>
        </div>
      </div>
    </div>

    <!-- Input Area -->
    <form
      v-if="cargaHabilitada"
      class="wrapper-input border"
      @submit.prevent="sendMessage"
    >
      <textarea
        v-model="newMessage"
        placeholder="Comentario"
        @keydown.enter.prevent="sendMessage"
        rows="1"
        max-rows="3"
        required
      ></textarea>
      <button type="submit" :disabled="sending">
        <i v-show="!sending" class="ti ti-send"></i>
        <i class="fa-solid fa-circle-notch fa-spin" v-show="sending"></i>
      </button>
    </form>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  props: {
    dataSendCommentFile: {
      type: Object,
      required: false,
      default: () => ({
        personaId: "",
        archivoId: "",
        // observacion: "",
        // fechaObservacion: "",
      }),
    },
    commentsFiles: {
      type: Array,
      required: false,
      default: () => [],
    },
    cargaHabilitada: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      messages: [],
      newMessage: "",
      sending: false,
    };
  },
  mounted() {
    this.personaAct = JSON.parse(localStorage.getItem("setPersonaAct"));
    console.log(this.personaAct.id);

    this.messages = this.commentsFiles.map((comment) => ({
      user: comment.PersonaId.toLowerCase() == this.personaAct.id ? "Tú" : "",
      text: comment.Observacion,
      fecha: comment.FechaObservacion,
    }));

    console.log(this.messages);

    this.scrollToBottom();
  },
  methods: {
    async sendMessage() {
      if (this.newMessage.trim() !== "") {
        this.sending = true;
        try {
          let data = {
            ...this.dataSendCommentFile,
            observacion: this.newMessage,
            fechaObservacion: this.$moment
              .tz(new Date(), "America/Bogota")
              .format("YYYY-MM-DDTHH:mm:ss"),
          };
          const res = await this.$store.dispatch("hl_post", {
            path: "CDC/AddObservacion",
            data,
          });

          console.log(res);
          if (res.id) {
            // Agregar el nuevo mensaje al chat
            this.messages.push({
              user: "Tú",
              text: this.newMessage,
              fecha: this.$moment
                .tz(new Date(), "America/Bogota")
                .format("YYYY-MM-DDTHH:mm:ss"),
            });

            const newComment = {
              ObservacionId: res.id,
              PersonaId: this.dataSendCommentFile.personaId,
              Observacion: this.newMessage,
              FechaObservacion: data.fechaObservacion,
            };

            this.commentsFiles?.push(newComment);

            this.messages = this.commentsFiles.map((comment) => ({
              user:
                comment.PersonaId.toLowerCase() == this.personaAct.id
                  ? "Tú"
                  : "",
              text: comment.Observacion,
              fecha: comment.FechaObservacion,
            }));
          }
        } catch (error) {
          console.error("Error al guardar cambios:", error);
          Swal.fire("Error!", "No se pudo agregar el comentario.", "error");
        } finally {
          this.newMessage = "";
          this.scrollToBottom();
          this.sending = false;
        }
      }
    },
    scrollToBottom() {
      this.$nextTick(() => {
        const chatMessages = this.$el.querySelector(".chat-messages");
        chatMessages.scrollTop = chatMessages.scrollHeight;
      });
    },
  },
};
</script>

<style scoped>
.wrapper-input {
  display: flex;
  align-items: center;
  border-radius: 2rem;
  overflow: auto !important;
  padding: 0.4rem 0.4rem;
  background-color: var(--body-bg);
  margin-top: 0.5rem;
  max-width: 400px;
  margin-inline: auto;
}

.wrapper-input textarea {
  width: 100%;
  border: none;
  resize: none;
  outline: none;
  background-color: transparent;
  overflow: hidden;
  .dark & {
    color: white;
  }
}

.wrapper-input textarea:focus + button {
  color: #1959f7;
}

.wrapper-input button {
  border: none;
  background-color: transparent;
  color: #ccc;
  font-size: 1.2rem;
  cursor: pointer;
  transition: color 0.3s ease;
  &:disabled {
    cursor: not-allowed;
  }
  &:disabled i {
    color: #1959f7;
  }
}

.chat-messages {
  white-space: normal;
  overflow-wrap: break-word;
  height: auto;
  min-height: 10vh;
  max-height: 30vh;
  background-color: var(--body-bg);
  border-radius: 5px;
  padding: 0 1rem;
  overflow-y: auto;
}

.chat-text {
  white-space: normal;
  overflow-wrap: break-word;
  padding: 0.7rem 1rem;
  border-radius: 0 1rem 1rem 1rem;
  &.right {
    border-radius: 1rem 0 1rem 1rem;
  }
}
</style>
